module.exports = __webpack_public_path__ + "img/1557614092763602945.5a056772.png";